// extracted by mini-css-extract-plugin
export default {"BriefFooter":"BriefFooter--Qjm5u"};